import * as Sentry from '@sentry/react';
import { router } from '../../router';

const userId = localStorage.getItem('user_id');
const userEmail = localStorage.getItem('user_email');
const organizationId = localStorage.getItem('organization_id');
const organizationName = localStorage.getItem('organization_name');

Sentry.init({
  attachStacktrace: true,
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_SENTRY_ENV,
  initialScope: {
    user: {
      id: userId || undefined,
      email: userEmail || undefined,
      username: userEmail || undefined,
    },
    extra: {
      organization_id: organizationId || undefined,
      organization_name: organizationName || undefined,
    },
    tags: {
      environment: import.meta.env.VITE_SENTRY_ENV,
      organization_name: organizationName || undefined,
    },
  },
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.extraErrorDataIntegration(),
    Sentry.httpClientIntegration({
      failedRequestStatusCodes: [[400, 599]],
      failedRequestTargets: [/^.*\.api\.vizit\.com$/, /^.*\.vizit\.com$/],
    }),
    Sentry.moduleMetadataIntegration(),
    Sentry.tanstackRouterBrowserTracingIntegration(router),
  ],
  tracesSampleRate: 0.05,
  tracePropagationTargets: [/^localhost$/, /^.*\.api\.vizit\.com$/, /^.*\.vizit\.com$/],
  tracesSampler: (samplingContext) => {
    const { inheritOrSampleWith } = samplingContext;

    // We can also use sampleContext to sample based on critical user flows.
    // See: https://docs.sentry.io/platforms/javascript/guides/react/tracing/configure-sampling/#traces-sampler-examples

    // Sample all transactions in local development
    if (import.meta.env.VITE_SENTRY_ENV === 'local') {
      return 1.0;
    }
    // Sample 5% in prod
    if (import.meta.env.VITE_SENTRY_ENV === 'prod') {
      return 0.05;
    }
    // Sample 20% in dev.app.vizit.com
    return inheritOrSampleWith(0.2);
  },
});
